import React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useCompanyDashboard } from "./CompanyDashboardProvider";
import { DashboardSidebar } from "./DashboardSidebar";
import "./styles.css";

export default function CompanyDashboardLayout() {
	const { companyId, company, isCompanyLoading, isCompanyError, user } = useCompanyDashboard();
	const [isCollapsed, setIsCollapsed] = React.useState(false);

	if (!companyId) {
		return <Navigate to="/companies" replace />;
	}

	return (
		<div className="company-dashboard-app min-h-screen bg-background">
			<DashboardSidebar
				user={user}
				isCollapsed={isCollapsed}
				onToggleCollapse={() => setIsCollapsed((value) => !value)}
			/>
			<div className={`min-h-screen transition-all duration-200 ${isCollapsed ? "ml-[72px]" : "ml-64"}`}>
				{isCompanyLoading ? (
					<div className="flex min-h-screen items-center justify-center">
						<div className="company-dashboard-subtle rounded-3xl border border-border px-8 py-10 text-center">
							<p className="text-lg font-semibold text-foreground">Loading company dashboard...</p>
							<p className="mt-1 text-sm text-muted-foreground">Fetching company details and available jobs.</p>
						</div>
					</div>
				) : isCompanyError || !company ? (
					<div className="flex min-h-screen items-center justify-center p-6">
						<div className="max-w-md rounded-3xl border border-red-100 bg-white p-8 text-center shadow-sm">
							<h1 className="text-xl font-bold text-foreground">Company dashboard unavailable</h1>
							<p className="mt-2 text-sm text-muted-foreground">
								We could not load this company. Check the company record and try the dashboard again.
							</p>
						</div>
					</div>
				) : (
					<Outlet />
				)}
			</div>
		</div>
	);
}
